import React, { useState, useEffect } from 'react';
import i18next from '../../i18n.js';
import moment from 'moment';

const Calendar = (props) => {
    const weekDayNums = Array.from({ length: 7 }, (_, i) => i);
    const [vacationIntervals, setVacationIntervals] = useState(null);
    const [items, setItems] = useState(null);

    useEffect(() => {
        updateItems();
    }, [props.year, props.month, props.showVacations, vacationIntervals]);

    useEffect(() => {
        if (props.vacations) {
            const year = parseInt(props.year);
            const month = parseInt(props.month);

            let firstDay = new Date(year, month, 1).getDay();
            if (firstDay == 0) firstDay = 7;
            firstDay--;
            const startCalendarDate = new Date(year, month, 1 - firstDay);

            const monthDays = new Date(year, month + 1, 0).getDate();
            let nextDaysCount = 42 - (firstDay + monthDays);
            const endCalendarDate = new Date(year, month + 1, nextDaysCount);

            //const date = moment("31.01.2025", 'DD.MM.YYYY').toDate();

            const intervals = [];
            
            props.vacations.forEach((vacation) => {
                const startDate = moment(vacation.fields.find(f => f.name === 'ClaimDateStart').value, 'DD.MM.YYYY').toDate();
                if (startDate <= endCalendarDate) {
                    const endDate = moment(vacation.fields.find(f => f.name === 'ClaimDateEnd').value, 'DD.MM.YYYY').toDate();
                    if (endDate >= startCalendarDate) {
                        intervals.push({
                            startDate: startDate,
                            endDate: endDate,
                        });
                    }
                }
            });
            setVacationIntervals(intervals);
        }
        else {
            setVacationIntervals(null);
        }
    }, [props.vacations, props.year, props.month]);

    const isVacation = (date) => props.showVacations && vacationIntervals && vacationIntervals.find(item => date >= item.startDate && date <= item.endDate);
    const isFirstDay = (date) => props.showVacations && vacationIntervals && vacationIntervals.find(item => date.getDate() == item.startDate.getDate() && date.getMonth() == item.startDate.getMonth() && date.getFullYear() == item.startDate.getFullYear());
    const isLastDay = (date) => props.showVacations && vacationIntervals && vacationIntervals.find(item => date.getDate() == item.endDate.getDate() && date.getMonth() == item.endDate.getMonth() && date.getFullYear() == item.endDate.getFullYear());

    const updateItems = () => {
        const year = parseInt(props.year);
        const month = parseInt(props.month);

        const items = [];
        let firstDay = new Date(year, month, 1).getDay();
        if (firstDay == 0) firstDay = 7;
        let prevMonthDays = new Date(year, month, 0).getDate();

        for (let i = 1; i < firstDay; i++) {
            const item = {
                day: prevMonthDays,
                classes: ['prev']
            };
            const date = new Date(year, month - 1, item.day);
            if (isVacation(date)) {
                item.classes.push('vacation');
                if (isFirstDay(date)) item.classes.push('first');
                if (isLastDay(date)) item.classes.push('last');
                
            }
            if (date.getDay() === 0 || date.getDay() === 6) {
                item.classes.push('rest');
            }
            items.unshift(item);
            prevMonthDays--;
        }
        const monthDays = new Date(year, month + 1, 0).getDate();
        for (let i = 1; i <= monthDays; i++) {
            const item = {
                day: i,
                classes: []
            }
            const date = new Date(year, month, item.day);
            if (isVacation(date)) {
                item.classes.push('vacation');
                if (isFirstDay(date)) item.classes.push('first');
                if (isLastDay(date)) item.classes.push('last');
            }
            if (date.getDay() === 0 || date.getDay() === 6) {
                item.classes.push('rest');
            }
            items.push(item);
        }
        let allDaysCount = firstDay - 1 + monthDays;
        let j = 1;
        while (allDaysCount < 42) {
            const item = {
                day: j,
                classes: ['next']
            };
            const date = new Date(year, month + 1, item.day);
            if (isVacation(date)) {
                item.classes.push('vacation');
                if (isFirstDay(date)) item.classes.push('first');
                if (isLastDay(date)) item.classes.push('last');
            }
            if (date.getDay() === 0 || date.getDay() === 6) {
                item.classes.push('rest');
            }
            items.push(item);
            allDaysCount++;
            j++;
        }
        setItems(items);
    }

    return <div className='calendar'>
        <div className='calendar-title'>{i18next.t(`calendar.months.${props.month}`)}</div>
        <div className='calendar-header'>{weekDayNums.map((dayNum) => <div key={dayNum} >{i18next.t(`calendar.weekDayTitles.${dayNum}`)}</div>)}</div>
        <div className='calendar-items'>
            {items && items.map((item, i) => <div key={`${props.year}-${props.month}-${item.day}-${i}`} className={'day ' + item.classes.join(' ')}><div className='label'>{item.day}</div></div>)}
        </div>
    </div>
}

export default Calendar;